import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import MoreVert from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import { getRenters, deleteRenter } from '../../store/renters/actions';
import Loader from '../../components/Layout/Loader';
import RenterDetails from '../../components/Renter/RenterDetails';
import NotFoundPage from '../NotFoundPage/NotFoundPage';
import { RENTER_EDIT, RENTERS } from '../../constants/routes';
import { getBikes } from '../../store/bikes/actions';
import { getSites } from '../../store/sites/actions';
import { ROLE_USER } from '../../constants/roles';
import {resetRents} from "../../store/rents/actions";

const styles = () => ({
  menuButton: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    bottom: '3vh',
    right: '3vh',
  },
});

export class RenterPage extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.props.resetRents();
    this.state = {
      anchorEl: null,
      renterId: this.props.match.params.renterId,
      renter: null,
      role: ROLE_USER,
      sending: false
    };
  }

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (props.authUser && props.roles) {
      const role = props.roles[props.authUser.uid];
      newState = {...newState, role:role};
      if (props.errorRenters === null && props.errorBikes === null && props.errorSites === null) {
        if (!props.bikes && !props.pendingBikes) {
          props.getBikes(props.authUser.ma, role);
        }
        if (!props.sites && !props.pendingSites) {
          props.getSites(props.authUser.ma, role);
        }
        if (!props.renters && !props.pendingRenters) {
          props.getRenters(props.authUser.ma, role);
        } else if (props.renters) {
          const foundRenter = props.renters.find(renter => renter.id === state.renterId);
          if (foundRenter) {
            newState = {
              ...newState,
              renter: foundRenter
            };
          } else {
            newState = {
              ...newState,
              renter: -1
            };
          }
        }
      }
    }
    return newState;
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleDelete = () => {
    this.props.deleteRenter(this.props.authUser.ma, this.state.renterId).then(value => {
      if (value) {
        this.props.history.push(RENTERS);
      }
    });
  };

  render() {
    const { anchorEl } = this.state;
    let renterDetail;
    let currentRenter;
    if (this.props.pending) {
      renterDetail = <Loader/>;
    } else if (this.props.renters && this.props.bikes && this.props.sites) {
      const renterIndex = this.props.renters
        .findIndex(renter => renter.id === this.state.renterId);
      if (renterIndex !== -1) {
        currentRenter = this.props.renters[renterIndex];
        const bikes = this.props.bikes.filter(bike => bike.renter_info_id === currentRenter.id);
        renterDetail =
          <div>
            <h1 style={stylesDefault.title}>Loueur - {currentRenter.name}</h1>
            <RenterDetails renter={currentRenter}
                           bikes={bikes}
                           sites={this.props.sites
                             .filter(site => site.renter_info_id === currentRenter.id)}
            />
          </div>;
      } else {
        return <NotFoundPage />;
      }
    }

    let menu;
    if (currentRenter && !currentRenter.remove) {
      menu =
        <div>
          <Fab
            id="button-menu"
            className={this.props.classes.menuButton}
            color="primary"
            onClick={this.handleClick}
            aria-label="menu">
            <MoreVert />
          </Fab>

          <Menu
            id="renter-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
          >
            <MenuItem
              id="item-edit"
              component={Link}
              to={RENTER_EDIT.replace(':renterId', this.state.renterId)}>
              Éditer
            </MenuItem>
            <MenuItem
              id="item-disable"
              onClick={this.handleDelete}
            >
              Désactiver
            </MenuItem>
          </Menu>
        </div>;
    }
    return (
      <LargePaper>
        {renterDetail}
        {menu}
      </LargePaper>
    );
  }
}

const mapStateToProps = state => ({
  authUser: state.users.authUser,
  roles: state.roles.content,
  pending: state.renters.pending
  || state.bikes.pending
  || state.sites.pending,
  sending: state.renters.sending,
  renters: state.renters.content,
  bikes: state.bikes.content,
  sites: state.sites.content,
  pendingRenters: state.renters.pending,
  pendingBikes: state.bikes.pending,
  pendingSites: state.sites.pending,
  errorRenters: state.renters.error,
  errorBikes: state.bikes.error,
  errorSites: state.sites.error
});

export default compose(
  withAuthorization(authUser => !!authUser),
  connect(mapStateToProps, {
    getRenters, getBikes, getSites, deleteRenter, resetRents
  }),
  withStyles(styles),
)(RenterPage);



// WEBPACK FOOTER //
// ./src/containers/RenterPage/RenterPage.jsx